import { useState, useEffect } from "react";
import Header from "../../../componente/header";
import "./style.css";
import api from "../../../services/api";
import Modal from "react-modal";
import { IMaskInput } from "react-imask";
import PopUp from "../../../componente/popup";
import Paginacao from "../../../componente/paginacao";
import PopUpMotivoExclusao from "../../../componente/popup";
import { podeInserir, podeEditar, podeExcluir } from "../../../componente/permissoes";

Modal.setAppElement("#root");

function CadFuncionario() {
  const { DateTime } = require("luxon");

  const [lista, setlista] = useState([]);
  const [abusca, setabusca] = useState("");
  const [showform, setshowform] = useState(false);

  const [edtcodfuncionario, setedtcodfuncionario] = useState(0);
  const [edtnome, setedtnome] = useState("");
  const [edtcep, setedtcep] = useState("");
  const [edtendereco, setedtendereco] = useState("");
  const [edtnumero, setedtnumero] = useState("");
  const [edtcomplemento, setedtcomplemento] = useState("");
  const [edtbairro, setedtbairro] = useState("");
  const [edtcidade, setedtcidade] = useState("");
  const [edttelefone, setedttelefone] = useState("");
  const [edtwhatsapp, setedtwhatsapp] = useState("");
  const [edtdtcadastro, setedtdtcadastro] = useState("");
  const [edtdtnascimento, setedtdtnascimento] = useState("");
  const [edtdtadimissao, setedtdtadimissao] = useState("");
  const [edtdtdemissao, setedtdtdemissao] = useState("");
  const [edtativo, setedtativo] = useState("");
  const [edtcpf, setedtcpf] = useState("");
  const [edtapelido, setedtapelido] = useState("");
  const [edtobservacao, setedtobservacao] = useState("");
  const [offset, setOffset] = useState(0);
  const [qtdetotalpag, setqtdetotalpag] = useState(0);

  const [novo, setnovo] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isOpenMotivoExclusao, setIsOpenMotivoExclusao] = useState(false);
  const [edtMotivo, setEdtMotivo] = useState("");

  const handleOpen = (cad) => {
    setedtcodfuncionario(cad.codfuncionario);
    setIsOpen(true);
  };

  const handleConfirma = () => {
    setIsOpen(false);
    setEdtMotivo("");
    setIsOpenMotivoExclusao(true);
  };

  const handleInformarMotivoExclusao = () => {
    if (edtMotivo !== "") {
      Excluir();
      setIsOpenMotivoExclusao(false);
      ListarFuncionario();
    } else {
      alert("Descreva o motivo antes de informar");
    }
  };

  const handleCloseMotivoExclusao = () => {
    setIsOpenMotivoExclusao(false);
  };

  const handleClose = () => {
    setIsOpen(false);
  };

  function ListarFuncionario() {
    api
      .get("v1/cadastro/funcionario", {
        params: {
          busca: abusca,
          usapaginacao:"S",
          offset,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setlista(response.data);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarFuncionario();
  }, [abusca, offset]);

  function ListarPaginas() {
    api
      .get("funcionario/pagtotal2", {
        params: {
          busca: abusca,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setqtdetotalpag(response.data.paginatotal);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  useEffect(() => {
    ListarPaginas();
  }, [abusca]);

  function Cadastrar() {
    api
      .post(
        "v1/cadastro/funcionario",
        {
          nome: edtnome,
          cep: edtcep,
          endereco: edtendereco,
          numero: edtnumero,
          complemento: edtcomplemento,
          bairro: edtbairro,
          cidade: edtcidade,
          telefone: edttelefone,
          whatsapp: edtwhatsapp,
          dtcadastro: edtdtcadastro,
          dtnascimento: edtdtnascimento,
          dtadimissao: edtdtadimissao,
          dtdemissao: edtdtdemissao,
          ativo: edtativo,
          excluido: "N",
          codempresa: 1,
          cpf: edtcpf,
          apelido: edtapelido,
          observacao: edtobservacao,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarFuncionario();
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Editar() {
    api
      .put(
        "v1/cadastro/funcionario",
        {
          codfuncionario: edtcodfuncionario,
          nome: edtnome,
          cep: edtcep,
          endereco: edtendereco,
          numero: edtnumero,
          complemento: edtcomplemento,
          bairro: edtbairro,
          cidade: edtcidade,
          telefone: edttelefone,
          whatsapp: edtwhatsapp,
          dtnascimento: edtdtnascimento,
          dtadimissao: edtdtadimissao,
          dtdemissao: edtdtdemissao,
          ativo: edtativo,
          cpf: edtcpf,
          apelido: edtapelido,
          observacao: edtobservacao,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
          },
        }
      )
      .then(() => {
        ListarFuncionario();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Excluir() {
    api
      .delete("v1/cadastro/funcionario", {
        params: {
          codfuncionario: edtcodfuncionario,
          motivo: edtMotivo,
          codusuario: localStorage.getItem("tempCodUsuario")
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(() => {
        ListarFuncionario();        
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }

  function Salvar() {
    novo ? Cadastrar() : Editar();
    setshowform(false);
  }

  function closeModal() {
    setshowform(false);
  }

  function openModalNovo() {
    setshowform(true);
    setnovo(true);

    setedtcodfuncionario(0);
    setedtnome("");
    setedtcep("");
    setedtendereco("");
    setedtnumero("");
    setedtcomplemento("");
    setedtbairro("");
    setedtcidade("");
    setedttelefone("");
    setedtwhatsapp("");

    const dt = new Date();
    const date =
      dt.getFullYear() +
      "-" +
      (dt.getMonth() + 1).toString().padStart(2, "0") +
      "-" +
      dt.getDate().toString().padStart(2, "0");
    let time =
      dt.getHours().toString().padStart(2, "0") +
      ":" +
      dt.getMinutes().toString().padStart(2, "0");
    let dtcadastro = date + "T" + time;

    setedtdtcadastro(dtcadastro);

    setedtdtnascimento("");
    setedtdtadimissao("");
    setedtdtdemissao("");
    setedtativo("S");
    setedtcpf("");
    setedtapelido("");
    setedtobservacao("");
  }

  function openModalEditar(props) {
    api
      .get("/v1/cadastro/funcionario/funcionarioum", {
        params: {
          codfuncionario: props.codfuncionario,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem("tempToken")}`,
        },
      })
      .then(function (response) {
        setshowform(true);
        setnovo(false);

        setedtcodfuncionario(response.data.codfuncionario);
        setedtnome(response.data.nome);
        setedtcep(response.data.cep);
        setedtendereco(response.data.endereco);
        setedtnumero(response.data.numero);
        setedtcomplemento(response.data.complemento);
        setedtbairro(response.data.bairro);
        setedtcidade(response.data.cidade);
        setedttelefone(response.data.telefone);
        setedtwhatsapp(response.data.whatsapp);

        const dt = new Date(response.data.dtcadastro);
        const date =
          dt.getFullYear() +
          "-" +
          (dt.getMonth() + 1).toString().padStart(2, "0") +
          "-" +
          dt.getDate().toString().padStart(2, "0");
        let time =
          dt.getHours().toString().padStart(2, "0") +
          ":" +
          dt.getMinutes().toString().padStart(2, "0");
        let dtcadastro = date + "T" + time;

        setedtdtcadastro(dtcadastro);

        if (response.data.dtnascimento == null) {
          setedtdtnascimento("");
        } else {
          const dt1 = DateTime.fromISO(response.data.dtnascimento)
            .plus({ hours: 3 })
            .toFormat("yyyy-MM-dd");

          setedtdtnascimento(dt1);
        }

        if (response.data.dtadimissao == null) {
          setedtdtadimissao("");
        } else {
          const dt2 = DateTime.fromISO(response.data.dtadimissao)
            .plus({ hours: 3 })
            .toFormat("yyyy-MM-dd");

          setedtdtadimissao(dt2);
        }

        if (response.data.dtdemissao == null) {
          setedtdtdemissao("");
        } else {
          const dt3 = DateTime.fromISO(response.data.dtdemissao)
            .plus({ hours: 3 })
            .toFormat("yyyy-MM-dd");

          setedtdtdemissao(dt3);
        }

        setedtativo(response.data.ativo);
        setedtcpf(response.data.cpf);
        setedtapelido(response.data.apelido);
        setedtobservacao(response.data.observacao);
      })
      .catch(function (err) {
        console.log("ops! ocorreu um erro: " + err);
      });
  }  

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div>
          <div>
            <PopUp isOpen={isOpen} onClose={handleClose}>
              <h2>Verificação</h2>
              <p>Tem certeza que deseja excluir esse registro?</p>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleConfirma}
                  >
                    Sim
                  </button>
                  <button className="btn btn-danger" onClick={handleClose}>
                    Não
                  </button>
                </div>
              </div>
            </PopUp>
          </div>

          <div>
            <PopUpMotivoExclusao isOpen={isOpenMotivoExclusao} onClose={handleCloseMotivoExclusao}>
              <h2>Antes de Excluir</h2>
              <p>Informe qual o motivo da exclusão?</p>

              <div className="col-sm-12">
                <label htmlFor="motivo" className="form-label">
                  Motivo
                </label>
                <input
                  type="text"
                  id="motivo"
                  className="form-control"
                  placeholder="Descreva aqui"
                  value={edtMotivo}
                  onChange={(e) => setEdtMotivo(e.target.value)}
                />
              </div>

              <div className="row">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button
                    className="btn btn-primary me-2"
                    onClick={handleInformarMotivoExclusao}
                  >
                    Informar
                  </button>
                  <button className="btn btn-danger" onClick={handleCloseMotivoExclusao}>
                    Cancelar
                  </button>
                </div>
              </div>
            </PopUpMotivoExclusao>
          </div>

          <Modal
            isOpen={showform}
            onRequestClose={closeModal}
            overlayClassName="modal-overlay"
            className="modal-content modal-xl"
          >
            <div className="container-fluid h-100">
              <div className="modal-header">
                {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
              </div>              

              <div className="modal-body">
                <form>
                  <div className="row col-sm-12">
                    <div className="col-sm-6">
                      <label htmlFor="nome" className="form-label">
                        Nome
                      </label>
                      <input
                        type="text"
                        id="nome"
                        className="form-control"
                        placeholder="Nome"
                        value={edtnome}
                        onChange={(e) => setedtnome(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="apelido" className="form-label">
                        Apelido
                      </label>
                      <input
                        type="text"
                        id="apelido"
                        className="form-control"
                        placeholder="Apelido"
                        value={edtapelido}
                        onChange={(e) => setedtapelido(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="cpf" className="form-label">
                        CPF
                      </label>
                      <IMaskInput
                        mask={"000.000.000-00"}
                        radix="."
                        id="cpf"
                        className="form-control"
                        placeholder="CPF"
                        value={edtcpf}
                        onAccept={(value) => setedtcpf(value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-3">
                      <label htmlFor="cep" className="form-label">
                        CEP
                      </label>
                      <IMaskInput
                        mask={"00000-000"}
                        radix="."
                        id="cep"
                        className="form-control"
                        placeholder="CEP"
                        value={edtcep}
                        onAccept={(value) => setedtcep(value)}
                      />
                    </div>

                    <div className="col-sm-7">
                      <label htmlFor="endereco" className="form-label">
                        Endereço
                      </label>
                      <input
                        type="text"
                        id="endereco"
                        className="form-control"
                        placeholder="Endereço"
                        value={edtendereco}
                        onChange={(e) => setedtendereco(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-2">
                      <label htmlFor="numero" className="form-label">
                        Número
                      </label>
                      <input
                        type="text"
                        id="numero"
                        className="form-control"
                        placeholder="Número"
                        value={edtnumero}
                        onChange={(e) => setedtnumero(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-4">
                      <label htmlFor="complemento" className="form-label">
                        Complemento
                      </label>
                      <input
                        type="text"
                        id="complemento"
                        className="form-control"
                        placeholder="Complemento"
                        value={edtcomplemento}
                        onChange={(e) => setedtcomplemento(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="bairro" className="form-label">
                        Bairro
                      </label>
                      <input
                        type="text"
                        id="bairro"
                        className="form-control"
                        placeholder="Bairro"
                        value={edtbairro}
                        onChange={(e) => setedtbairro(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="cidade" className="form-label">
                        Cidade
                      </label>
                      <input
                        type="text"
                        id="cidade"
                        className="form-control"
                        placeholder="Cidade"
                        value={edtcidade}
                        onChange={(e) => setedtcidade(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-4">
                      <label htmlFor="telefone" className="form-label">
                        Telefone
                      </label>
                      <IMaskInput
                        mask={"(00) 0 0000-0000"}
                        radix="."
                        id="telefone"
                        className="form-control"
                        placeholder="Telefone"
                        value={edttelefone}
                        onAccept={(value) => setedttelefone(value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <label htmlFor="whatsapp" className="form-label">
                        WhatsApp
                      </label>
                      <IMaskInput
                        mask={"(00) 0 0000-0000"}
                        radix="."
                        id="whatsapp"
                        className="form-control"
                        placeholder="WhatsApp"
                        value={edtwhatsapp}
                        onAccept={(value) => setedtwhatsapp(value)}
                      />
                    </div>

                    <div className="col-sm-4">
                      <div>
                        <label htmlFor="ativo1" className="form-label">
                          Ativo
                        </label>
                        <br />
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="S"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "S"}
                          />
                          <label
                            className="form-check-label"
                            for="inlineRadio1"
                          >
                            Sim
                          </label>
                        </div>

                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="ativo"
                            value="N"
                            onChange={(e) => setedtativo(e.target.value)}
                            checked={edtativo === "N"}
                          />
                          <label className="form-check-label">Não</label>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-3">
                      <label htmlFor="dtcadastro" className="form-label">
                        Dt. Cadastro
                      </label>
                      <input
                        type="datetime-local"
                        id="dtcadastro"
                        className="form-control"
                        value={edtdtcadastro}
                        onChange={(e) => setedtdtcadastro(e.target.value)}
                        disabled
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="dtnascimento" className="form-label">
                        Dt. Nascimento
                      </label>
                      <input
                        type="date"
                        id="dtnascimento"
                        className="form-control"
                        value={edtdtnascimento}
                        onChange={(e) => setedtdtnascimento(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="dtadimissao" className="form-label">
                        Dt. Admissão
                      </label>
                      <input
                        type="date"
                        id="dtadimissao"
                        className="form-control"
                        placeholder="00/00/0000"
                        value={edtdtadimissao}
                        onChange={(e) => setedtdtadimissao(e.target.value)}
                      />
                    </div>

                    <div className="col-sm-3">
                      <label htmlFor="dtdemissao" className="form-label">
                        Dt. Demissão
                      </label>
                      <input
                        type="date"
                        id="dtdemissao"
                        className="form-control"
                        placeholder="00/00/0000"
                        value={edtdtdemissao}
                        onChange={(e) => setedtdtdemissao(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="row col-sm-12">
                    <div className="col-sm-12">
                      <label htmlFor="observacao" className="form-label">
                        Observação
                      </label>
                      <textarea
                        rows={3}
                        wrap="true"
                        id="observacao"
                        className="form-control"
                        placeholder="Observação"
                        value={edtobservacao}
                        onChange={(e) => setedtobservacao(e.target.value)}
                      />
                    </div>
                  </div>
                </form>
              </div>

              <div className="modal-footer">
                <div className="col-12 mt-3 d-flex justify-content-end">
                  <button className="btn btn-danger ms-4" onClick={closeModal}>
                    Cancelar
                  </button>
                  <button className="btn btn-success ms-4" onClick={Salvar}>
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </Modal>
        </div>

        <div className="row">
          <h1 className="ms-4">Cadastro de Funcionários</h1>
          <p className="ms-4">
            Rotina para cadastrar todos os funcionários da empresa
          </p>
          <hr />
        </div>

        <div className="row">
          <div className="col-10">
            <label className="d-block" htmlFor="busca">
              Busque aqui
            </label>
            <input
              type="text"
              placeholder="Buscar por: Código ou Nome"
              name="busca"
              id="busca"
              className="form-control me-3"
              value={abusca}
              onChange={(e) => {
                setabusca(e.target.value);
                setOffset(0);
              }}
            />
          </div>
          <div className="col-2 d-flex justify-content-center">
            <button
              className="btn btn-success btnnovo"
              onClick={() => openModalNovo()}
              disabled={!podeInserir("/cadastro/funcionario")}
            >
              Novo
            </button>
          </div>
        </div>

        <div className="row mt-3">
          <hr />
        </div>

        <div className="row tabela">
          <table className="table table-hover">
            <thead>
              <tr>
                <th className="codigo">Código</th>
                <th className="razao">Nome</th>
                <th className="fantasia">Telefone</th>
                <th className="cnpj">WhatsApp</th>
                <th className="acao">Ações</th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr key={item.codfuncionario}>
                    <th>{item.codfuncionario}</th>
                    <th>{item.nome}</th>
                    <th>{item.telefone}</th>
                    <th>{item.whatsapp}</th>
                    <th>
                      <div className="d-flex justify-content-center">
                        <button
                          className="btn fa-regular fa-pen-to-square"
                          onClick={() => openModalEditar(item)}
                          disabled={!podeEditar("/cadastro/funcionario")}
                        ></button>
                        <button
                          className="btn fa-solid fa-trash"
                          onClick={() => handleOpen(item)}
                          disabled={!podeExcluir("/cadastro/funcionario")}
                        ></button>
                      </div>
                    </th>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5}>Quantidade de Registros: {lista.length}</th>
              </tr>
            </tfoot>
          </table>
          <div className="row">
            <Paginacao
              limit={20}
              total={qtdetotalpag}
              offset={offset}
              setOffset={setOffset}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default CadFuncionario;
